(() => {
    let e, t, i;
    class r extends HTMLElement {
        connectedCallback() {
            (this.Cart = this), (this.isCartPage = document.body.classList.contains("template-cart")), (this.sectionId = this.getAttribute("cart-section-id")), (this.hasFreeProductBeenRemoved = !1), this.initCart();
        }
        initCart() {
            window.addEventListener("pageshow", (e) => {
                e.persisted &&
                    (document.body.classList.add("cart-is-updating"),
                    this.getSectionsToRender().forEach((e) => {
                        fetch(`${routes.cart_url}?section_id=${e.id}`)
                            .then((e) => e.text())
                            .then((t) => {
                                let i = new DOMParser().parseFromString(t, "text/html").querySelector(e.selector);
                                document.querySelector(e.selector).innerHTML = i.innerHTML;
                            })
                            .catch((e) => {
                                document.body.classList.remove("cart-is-updating"), console.error(e);
                            });
                    }),
                    document.body.classList.remove("cart-is-updating"));
            });
        }
        updateCart(e) {
            document.body.classList.add("cart-is-updating"),
                this.getSectionsToRender().forEach((t) => {
                    document.querySelector(t.selector).innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector);
                }),
                setTimeout(() => {
                    let e = document.querySelector("variant-radios");
                    e?.renderProductInfo();
                }, 800),
                document.body.classList.remove("cart-is-updating"),
                window.lozadObserver.observe();
        }
        getSectionsToRender() {
            return this.isCartPage
                ? [
                      { id: this.sectionId, selector: "#main-cart" },
                      { id: "cart-icon-bubble", selector: "#cart-icon-bubble" },
                  ]
                : [
                      { id: this.sectionId, selector: "w3-drawer-cart .drawer__main" },
                      { id: this.sectionId, selector: "w3-drawer-cart .drawer__main" },
                      { id: this.sectionId, selector: "w3-drawer-cart .drawer__footer" },
                      { id: "cart-icon-bubble", selector: "#cart-icon-bubble" },
                  ];
        }
        getSectionInnerHTML(e, t) {
            return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
        }
        displayErrorMessage(e) {
            (this.cartError = this.querySelector(".js-cart-error-message")), this.cartError && e && (this.cartError.classList.add("visible"), (this.cartError.querySelector(".js-cart-error-text").innerHTML = e));
        }
    }
    customElements.define("w3-cart", r);
    class a extends HTMLElement {
        connectedCallback() {
            (this.CartItems = this),
                (this.Cart = this.closest("w3-cart")),
                (this.isFreeProductEligible = this.CartItems.hasAttribute("free-product-eligible")),
                (this.isFreeProductNoLongerEligible = this.CartItems.hasAttribute("free-product-no-longer-eligible")),
                this.isFreeProductEligible && !this.Cart.hasFreeProductBeenRemoved && this.CartItems.addProduct(this.CartItems.dataset.freeProductId, 1, !0);
        }
        addProduct(e, t, i = !1) {
            document.body.classList.add("cart-is-updating");
            let s = { id: e, quantity: t, properties: {}, sections: this.Cart.getSectionsToRender().map((e) => e.id), sections_url: window.location.pathname };
            i && (s.properties._free_product = "1");
            let r = JSON.stringify(s);
            fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body: r })
                .then((e) => e.json())
                .then((e) => {
                    if (e.errors) {
                        this.Cart.displayErrorMessage(e.errors), document.body.classList.remove("cart-is-updating");
                        return;
                    }
                    this.Cart.updateCart(e);
                })
                .finally(() => {
                    document.body.classList.remove("cart-is-updating"), window.lozadObserver.observe();
                })
                .catch((e) => {
                    console.error(e), document.body.classList.add("cart-is-updating");
                });
        }
        updateQuantity(e, t) {
            (this.Cart = this.closest("w3-cart")), document.body.classList.add("cart-is-updating");
            let i = JSON.stringify({ line: e, quantity: t, sections: this.Cart.getSectionsToRender().map((e) => e.id), sections_url: window.location.pathname });
            fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: i })
                .then((e) => e.json())
                .then((e) => {
                    if (e.errors) {
                        this.Cart.displayErrorMessage(e.errors), document.body.classList.remove("cart-is-updating");
                        return;
                    }
                    this.Cart.updateCart(e);
                })
                .finally(() => {
                    document.body.classList.remove("cart-is-updating"), window.lozadObserver.observe();
                })
                .catch((e) => {
                    console.error(e), document.body.classList.add("cart-is-updating");
                });
        }
    }
    customElements.define("w3-cart-items", a);
    class n extends HTMLElement {
        constructor() {
            super(),
                this.addEventListener("click", (e) => {
                    e.preventDefault(), e.target.closest("w3-cart-free-product") && (this.closest("w3-cart").hasFreeProductBeenRemoved = !0), this.closest("w3-cart-items").updateQuantity(this.dataset.index, 0);
                });
        }
    }
    customElements.define("cart-remove-button", n);
    class l extends HTMLElement {
        constructor() {
            super(),
                this.addEventListener("click", (e) => {
                    e.preventDefault();
                    if(this.dataset.url !== undefined && this.dataset.url !== ""){
                        document.location.href = this.dataset.url;
                    }else{
                        let t = parseInt(this.dataset.currentQuantity) + parseInt(this.dataset.targetQuantity);
                        this.closest("w3-cart-items").updateQuantity(this.dataset.index, t);
                    }
                });
        }
    }
    customElements.define("cart-update-quantity-button", l);
    class o extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            let e = this.closest("w3-cart-items");
            e.isFreeProductNoLongerEligible && e.updateQuantity(this.dataset.index, 0);
        }
    }
    customElements.define("w3-cart-free-product", o);
    class d extends HTMLElement {
        constructor() {
            super(),
                (this.bindEvents = this.bindEvents.bind(this)),
                (this.openDrawer = this.openDrawer.bind(this)),
                (this.closeDrawer = this.closeDrawer.bind(this)),
                (this.onClickOutside = this.onClickOutside.bind(this)),
                (this.createCustomEvents = this.createCustomEvents.bind(this)),
                (this.onEchap = this.onEchap.bind(this));
        }
        connectedCallback() {
            (this.Drawer = this),
                (this.drawerSidebarEl = this.getElement(".js-drawer-sidebar")),
                (this.drawerOverlayEl = this.getElement(".js-drawer-overlay")),
                (this.hasCustomEvents = this.Drawer.hasAttribute("has-custom-event") || !1),
                (this.disableClickOutside = this.Drawer.hasAttribute("disable-click-outside") || !1),
                (this.drawerName = this.getAttribute("drawer-name") || "drawer"),
                (this.isDrawerMobile = this.Drawer.hasAttribute("mobile-only") || !1),
                (this.isDrawerOpen = !1),
                (this.isAnyDrawerVisible = !1),
                (this.mobileBreakpoint = 1024),
                (this.bodyTopPosition = 0),
                (this.speed = parseInt(this.Drawer.getAttribute("speed-transition")) || 600),
                (this.isMobile = this.checkIfMobile()),
                (this.forceLockScroll = this.Drawer.hasAttribute("force-lock-scroll") || !1),
                (!this.isDrawerMobile || this.isMobile) && this.bindEvents();
        }
        openDrawer() {
            this.isDrawerOpen ||
                (this.hasCustomEvents && this.Drawer.dispatchEvent(this.customEventDrawerOpen),
                this.Drawer.getAttribute("closer") ? (this.drawerBtnsClose = document.querySelectorAll(this.Drawer.getAttribute("closer"))) : (this.drawerBtnsClose = this.Drawer.querySelectorAll(".js-drawer-close")),
                void 0 !== this.drawerBtnsClose &&
                    this.drawerBtnsClose.length > 0 &&
                    this.drawerBtnsClose.forEach((e) => {
                        e.addEventListener("click", this.closeDrawer);
                    }),
                document.body.classList.add("drawer-visible", `${this.drawerName}-visible`),
                this.Drawer.classList.add("drawer--visible"),
                setTimeout(() => {
                    this.isMobile && this.lockScroll(), (this.isDrawerOpen = !0), document.addEventListener("keyup", this.onEchap), document.addEventListener("click", this.onClickOutside), window.lozadObserver.observe();
                }, this.speed));
            if (this.forceLockScroll){
                this.lockScroll()
            }
        }
        closeDrawer() {
            this.isDrawerOpen &&
                (this.hasCustomEvents && this.Drawer.dispatchEvent(this.customEventDrawerClose),
                this.Drawer.classList.add("drawer-transition-out"),
                document.removeEventListener("keyup", this.onEchap),
                document.removeEventListener("click", this.onClickOutside),
                this.isMobile && this.unLockScroll(),
                setTimeout(() => {
                    (this.isDrawerOpen = !1),
                        this.Drawer.classList.remove("drawer--visible", "drawer-transition-out"),
                        document.body.classList.remove(`${this.drawerName}-visible`),
                        this.isAnyDrawerVisible || document.body.classList.remove("drawer-visible");
                }, this.speed));
            if (this.forceLockScroll){
                this.unLockScroll()
            }
        }
        lockScroll() {
            (this.bodyTopPosition = document.documentElement.scrollTop), (document.body.style.top = `-${this.bodyTopPosition}px`), document.documentElement.classList.add("lock-scroll");
        }
        unLockScroll() {
            document.documentElement.classList.remove("lock-scroll"), window.scrollTo({ left: 0, top: this.bodyTopPosition, behavior: "instant" }), (document.body.style.top = "unset");
        }
        onEchap(e) {
            //ne ferme pas le drawer si la lightbox est ouverte
            if (document.body.classList.contains('pack-is-lightbox-open')) {
                return;
            }
            27 === e.keyCode && this.closeDrawer();
        }
        onClickOutside(e) {
            //ne ferme pas le drawer si la lightbox est ouverte
            if (document.body.classList.contains('pack-is-lightbox-open')) {
                return;
            }
            this.drawerSidebarEl.contains(e.target) || this.disableClickOutside || this.closeDrawer();
        }
        createCustomEvents() {
            (this.customEventDrawerOpen = new CustomEvent("drawer--open", { bubbles: !0, cancelable: !0, composed: !1 })), (this.customEventDrawerClose = new CustomEvent("drawer--close", { bubbles: !0, cancelable: !0, composed: !1 }));
        }
        getElement(e, t = !1) {
            return t ? this.Drawer.querySelectorAll(e) || [] : this.Drawer.querySelector(e) || null;
        }
        checkIfMobile() {
            return window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
        }
        checkIfAnyDrawerVisible() {
            document.body.classList.contains("drawer-visible") && (this.isAnyDrawerVisible = !0);
        }
        bindEvents() {
            if ((this.Drawer.getAttribute("opener") && (this.drawerBtnsOpen = document.querySelectorAll(this.Drawer.getAttribute("opener"))), this.drawerBtnsOpen))
                for (let e of this.drawerBtnsOpen) e.addEventListener("click", this.openDrawer);
            this.drawerOverlayEl &&
                this.drawerOverlayEl.addEventListener("click", () => {
                    this.closeDrawer();
                }),
                this.hasCustomEvents && this.createCustomEvents();
        }
        disconnectedCallback() {
            if (this.drawerBtnsOpen) for (let e of this.drawerBtnsOpen) e.removeEventListener("click", this.openDrawer);
            void 0 !== this.drawerBtnsClose &&
                this.drawerBtnsClose.length > 1 &&
                this.drawerBtnsClose.forEach((e) => {
                    e.removeEventListener("click", this.closeDrawer);
                });
        }
    }
    void 0 === customElements.get("w3-drawer") && customElements.define("w3-drawer", d),
        customElements.define(
            "w3-drawer-cart",
            class extends d {
                constructor() {
                    super();
                }
                connectedCallback() {
                    super.connectedCallback(), window.location.href.includes("cart=view") && this.openDrawer();
                }
                openDrawer() {
                    //dispatch new event name cart-custom:open
                    console.log("drawer open",this)
                    document.dispatchEvent(new CustomEvent("gong:cart:open"));
                    super.openDrawer();
                }
                closeDrawer() {
                    super.closeDrawer();
                }
                bindEvents() {
                    document.addEventListener("theme:drawer:cart:open", (e) => {
                        this.openDrawer();
                    }),
                        super.bindEvents();
                }
            }
        ),
        customElements.define(
            "w3-drawer-navigation",
            class extends d {
                constructor() {
                    super();
                }
                connectedCallback() {
                    super.connectedCallback();
                }
                openDrawer() {
                    setTimeout(() => {
                        document.body.classList.add("drawer-navigation--visible");
                    }, 50),
                        super.openDrawer();
                }
                closeDrawer() {
                    setTimeout(() => {
                        document.body.classList.remove("drawer-navigation--visible");
                    }, 300),
                        super.closeDrawer();
                }
            }
        ),
        customElements.define(
            "w3-drawer-search",
            class extends d {
                constructor() {
                    super();
                }
                connectedCallback() {
                    super.connectedCallback();
                }
                openDrawer() {
                    super.openDrawer();
                }
                closeDrawer() {
                    super.closeDrawer();
                }
            }
        );
    let p = "collection_couleur:",
        m = async ({ sectionId: e, collectionColor: t, multipleCollectionColor: i }) => {
            e || console.log("section_id is required");
            let s = `/search?resources[type]=product&section_id=${e}`;
            t && (s += `&q=${p}${t}`), i && ((i = i.map((e) => `${p}${e}`).join(" OR ")), (s += `&q=${i}`));
            let r = await fetch(s, { cache: "force-cache" });
            return await r.text();
        };
    class v extends HTMLElement {
        constructor() {
            super(),
                // (this.loadProductCardOptions = this.loadProductCardOptions.bind(this)),
                (this.loadProductCardColorsFromProducts = this.loadProductCardColorsFromProducts.bind(this)),
                (this.loadProductCardColorsFromVariants = this.loadProductCardColorsFromVariants.bind(this)),
                (this.mobileBreakpoint = 1024),
                (this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches);
        }
        connectedCallback() {
            this.ProductCard = this;
            if (!this.ProductCard.hasAttribute("product-card-unavailable")) {
                this.initProductCard();
            }
        }
        initProductCard() {
            (this.productHandle = this.ProductCard.dataset.handle),
                (this.productColorsContainer = this.ProductCard.querySelector("#product-card-colors")),
                // this.ProductCard.addEventListener("mouseenter", this.loadProductCardOptions),
                this.productColorsContainer &&
                    ((this.productColorType = this.ProductCard.querySelector("#product-card-colors").getAttribute("color-type")),
                    (this.collectionColor = this.ProductCard.querySelector("#product-card-colors").getAttribute("collection-color")),
                    "product_with_collection_for_colors" == this.productColorType
                        ? this.loadProductCardColorsFromProducts()
                        : "product_with_color_variants" == this.productColorType && this.loadProductCardColorsFromVariants());
        }
        loadProductCardOptions() {
            (this.optionsContainer = this.ProductCard.querySelector(".js-product-card-options")),
                this.optionsContainer != null,
                this.productHandle && this.optionsContainer && this.ProductCard.classList.add("product-card--options-loading"),
                fetch(`${window.Shopify.routes.root}products/${this.productHandle}?view=options`)
                    .then((e) => {
                        if (!e.ok) {
                            var t = Error(e.status);
                            throw (this.ProductCard.classList.remove("product-card--options-loading"), t);
                        }
                        return e.text();
                    })
                    .then((e) => {
                        if(this.optionsContainer == null){
                            return;
                        }
                        let t = new DOMParser().parseFromString(e, "text/html").querySelector(".product-card-options-wrapper").innerHTML;
                        t && (this.ProductCard.classList.remove("product-card--options-loading"), (this.optionsContainer.innerHTML = t), this.ProductCard.removeEventListener("mouseenter", this.loadProductCardOptions));
                    })
                    .catch((e) => {
                        throw (this.ProductCard.classList.remove("product-card--options-loading"), e);
                    });
        }
        async loadProductCardColorsFromProducts() {
            if (!this.eventProcessed)
                try {
                    this.ProductCard.classList.add("product-card--colors-loading");
                    let e = await m({ collectionColor: this.collectionColor, sectionId: "product-card-colors" }),
                        t = new DOMParser().parseFromString(e, "text/html");
                    (t = t.querySelector(".shopify-section")),
                        (this.productColorsContainer.innerHTML = t.outerHTML),
                        (this.eventProcessed = !0),
                        this.ProductCard.classList.remove("product-card--colors-loading"),
                        this.ProductCard.removeEventListener("mouseenter", this.loadProductCardColorsFromProducts);
                } catch (e) {
                    console.error("Une erreur s'est produite lors du chargement des couleurs :", e);
                }
        }
        async loadProductCardColorsFromVariants() {
            this.productHandle && this.ProductCard.classList.add("product-card--colors-loading"),
                fetch(`${window.Shopify.routes.root}products/${this.productHandle}?view=colors`)
                    .then((e) => {
                        if (!e.ok) {
                            var t = Error(e.status);
                            throw (this.ProductCard.classList.remove("product-card--colors-loading"), t);
                        }
                        return e.text();
                    })
                    .then((e) => {
                        this.ProductCard.classList.remove("product-card--colors-loading"), (this.productColorsContainer.innerHTML = e), this.ProductCard.removeEventListener("mouseenter", this.loadProductCardColorsFromVariants);
                    })
                    .catch((e) => {
                        throw (this.ProductCard.classList.remove("product-card--colors-loading"), e);
                    });
        }
    }
    customElements.define("w3-product-card", v);
    class f extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            (this.form = this.querySelector("form")), this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), (this.Cart = document.querySelector("w3-cart"));
        }
        onSubmitHandler(e) {
            if ((e && e.preventDefault(), (this.submitButton = this.querySelector('[type="submit"]')), this.submitButton.classList.contains("button-loading"))) return;
            this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.classList.add("button-loading");
            let t = { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/javascript" } };
            (t.headers["X-Requested-With"] = "XMLHttpRequest"), delete t.headers["Content-Type"];
            let i = new FormData(this.form);
            this.Cart &&
                (i.append(
                    "sections",
                    this.Cart.getSectionsToRender().map((e) => e.id)
                ),
                i.append("sections_url", window.location.pathname)),
                (t.body = i);
            let s = null;
            this.getAttribute("data-delay") && (s = 4e3),
                fetch(`${routes.cart_add_url}`, t)
                    .then((e) => e.json())
                    .then((e) => {
                        if (e.status) {
                            this.handleErrorMessage(e.description);
                            return;
                        }
                        let t = new CustomEvent("theme:drawer:cart:pre-open");
                        if ((document.dispatchEvent(t), s))
                            console.log("Cart will update in " + s + ", to take into account parallel changes..."),
                                setTimeout(() => {
                                    let e = { line: 1, sections: this.Cart.getSectionsToRender().map((e) => e.id), sections_url: window.location.pathname };
                                    fetch(`${window.routes.cart_change_url}.js`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(e) })
                                        .then((e) => e.json())
                                        .then((e) => {
                                            this.Cart && this.Cart.updateCart(e), console.log("...Now updating cart after second cart request");
                                            let t = new CustomEvent("theme:drawer:cart:open", { detail: { cart: e } });
                                            document.dispatchEvent(t), this.submitButton.classList.remove("button-loading"), this.submitButton.removeAttribute("aria-disabled");
                                        });
                                }, s);
                        else {
                            this.Cart && this.Cart.updateCart(e);
                            let t = new CustomEvent("theme:drawer:cart:open", { detail: { cart: e } });
                            document.dispatchEvent(t), this.submitButton.classList.remove("button-loading"), this.submitButton.removeAttribute("aria-disabled");
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                    });
        }
        handleErrorMessage(e = !1) {
            if (((this.errorMessageWrapper = this.querySelector(".product-form__error-message-wrapper")), (this.errorMessage = this.errorMessageWrapper.querySelector(".product-form__error-message")), "object" == typeof e)) {
                let t = "";
                for (let i in e)
                    if (e.hasOwnProperty(i)) {
                        let s = e[i];
                        console.log(s);
                        let r = s.join(", "),
                            a = window.translations.recipient[i];
                        t += `${a} ${r}. `;
                    }
                (this.errorMessageWrapper.hidden = !e), (this.errorMessage.textContent = t);
            } else (this.errorMessageWrapper.hidden = !e), (this.errorMessage.textContent = e);
        }
    }
    void 0 === customElements.get("product-form") && customElements.define("product-form", f);
    class w extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            (this.Navigation = this),
                (this.NavigationDrawer = this.Navigation.querySelector("w3-drawer-navigation")),
                (this.navigationLinks = this.Navigation.querySelectorAll(".js-navigation-link")),
                (this.activeSubmenus = []),
                (this.isNavigationInit = !1),
                (this.currentMenuLevel = this.getCurrentLevel()),
                (this.mobileBreakpoint = 1199),
                (this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches),
                this.isMobile ? this.initMobileNavigation() : this.initDesktopNavigation();
        }
        getCurrentLevel() {
            return parseInt(this.Navigation.dataset.currentLevel);
        }
        updateCurrentLevel(e) {
            this.Navigation.dataset.currentLevel = e;
        }
        showSubmenu(e) {
            let t = e.dataset.name,
                i = this.Navigation.querySelector(`ul[data-parent-name="${t}"]`);
            this.isMobile ? this.showMobileSubmenu(i) : this.showDesktopSubmenu(e, i);
        }
        initDesktopNavigation() {
            (this.isNavItemHover = !1),
                (this.navigationEnterTimeout = {}),
                this.isNavigationInit ||
                    (this.NavigationDrawer.addEventListener("drawer--open", (e) => {
                        this.setupDrawerEventListeners();
                    }),
                    this.NavigationDrawer.addEventListener("drawer--close", (e) => {
                        this.resetNavigationDesktop();
                    }),
                    (this.isNavigationInit = !0));
        }
        setupDrawerEventListeners() {
            for (let e of this.navigationLinks) e.addEventListener("mouseenter", () => this.handleMouseEnter(e)), e.addEventListener("mouseleave", () => this.handleMouseLeave());
        }
        handleMouseEnter(e) {
            this.navigationEnterTimeout = setTimeout(() => this.showSubmenu(e), 100);
        }
        handleMouseLeave() {
            (this.isNavItemHover = !1), clearTimeout(this.navigationEnterTimeout);
        }
        showDesktopSubmenu(e, t) {
            let i = this.getCurrentLevel();
            if (t === this.activeSubmenus[i]) return;
            let s = e.closest("ul"),
                r = parseInt(s.dataset.level);
            if (1 === r) {
                for (let e = 0; e < this.activeSubmenus.length; e++) this.activeSubmenus[e] && this.activeSubmenus[e].classList.remove("submenu-visible");
                this.activeSubmenus = [];
            }
            if (r <= i) {
                let e = this.getCurrentLevel();
                this.activeSubmenus[e]?.classList.remove("submenu-visible"), this.activeSubmenus.splice(e, 1);
            }
            this.updateCurrentLevel(r), (1 === r || 2 === r) && (this.activeSubmenus[1] = s), t && (t?.classList.add("submenu-visible"), (this.activeSubmenus[this.getCurrentLevel()] = t));
        }
        resetNavigationDesktop() {
            for (let [e, t] of ((this.Navigation.dataset.currentLevel = 1), Object.entries(this.activeSubmenus))) t.classList.remove("submenu-visible");
            this.activeSubmenus = [];
        }
        initMobileNavigation() {
            this.NavigationDrawer.addEventListener("drawer--open", (e) => {
                (this.navigationTitle = this.Navigation.querySelector(".js-nav-title")),
                    (this.buttonPrevLevel = this.NavigationDrawer.querySelector(".js-button-prev")),
                    this.isNavigationInit ||
                        (this.initSubmenus(),
                        this.NavigationDrawer.addEventListener("drawer--close", (e) => {
                            this.resetSubmenus();
                        }),
                        (this.isNavigationInit = !0));
            });
        }
        initSubmenus() {
            if (this.navigationLinks.length > 0)
                for (let e = 0; e < this.navigationLinks.length; e++)
                    this.navigationLinks[e].addEventListener("click", (t) => {
                        this.navigationLinks[e].hasAttribute("has-submenu") && (t.preventDefault(), this.showSubmenu(this.navigationLinks[e]));
                    });
            this.buttonPrevLevel &&
                this.buttonPrevLevel.addEventListener("click", () => {
                    this.hideSubmenu();
                });
        }
        showMobileSubmenu(e) {
            let t = this.getCurrentLevel() + 1;
            this.updateCurrentLevel(t), e.classList.add("submenu-visible"), (this.activeSubmenus[this.getCurrentLevel()] = e), this.updateCurrentTitle();
        }
        hideSubmenu() {
            let e = this.activeSubmenus[this.getCurrentLevel()];
            if (e) {
                e.classList.remove("submenu-visible"), delete this.activeSubmenus[this.getCurrentLevel()];
                let t = this.getCurrentLevel() - 1;
                this.updateCurrentLevel(t), this.updateCurrentTitle();
            }
        }
        resetSubmenus() {
            for (let [e, t] of ((this.Navigation.dataset.currentLevel = 1), this.updateCurrentTitle(), Object.entries(this.activeSubmenus))) t.classList.remove("submenu-visible");
            this.activeSubmenus = [];
        }
        updateCurrentTitle() {
            let e = this.getCurrentLevel();
            if (1 == e) this.navigationTitle.innerHTML = "";
            else if (this.activeSubmenus[e]) {
                let t = this.activeSubmenus[e].dataset.parentTitle;
                this.navigationTitle.innerHTML = t;
            }
        }
    }
    customElements.define("w3-navigation", w);
})();
